export default __webpack_public_path__ + "static/media/galerie3.4f90a9f1.jpg";